var _script;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThorchain = function SvgThorchain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253.3 290.5",
    style: {
      enableBackground: "new 0 0 253.3 290.5"
    },
    xmlSpace: "preserve",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thorchain_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: -321.725,
    y1: 644.281,
    x2: -320.725,
    y2: 644.281,
    gradientTransform: "matrix(253.26 0 0 -290.5 81479.977 187309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0cf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3f9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 290.5 202.8-85.4-64.2-65.1L0 290.5zM74.5 75l64.2 65L253.3 0 74.5 75z",
    style: {
      fill: "url(#thorchain_svg__a)"
    }
  }), _script || (_script = /*#__PURE__*/React.createElement("script", null)));
};
export default SvgThorchain;